import React from "react";
import "./template1.css";

const Objective = () => {
    return (
        <>
            <div contentEditable={true} className="heading">
                <div className="title">OBJECTIVE</div>
                <div className="element"></div>
                <div className="objectInfo">Your Objective come here ....</div>
            </div>

        </>
    )
}

export default Objective;